import type {
  ArenaContestResponse,
  OddsType,
  PredictionStatus,
  PredictionStatuses,
  TransformedArenaContestResponse,
  TransformedArenaContestResponses
} from '@library/types/arenaContest';

export const transformArenaContestResponse = (
  response: ArenaContestResponse | undefined
): TransformedArenaContestResponses => {
  if (!response) {
    return [];
  }

  const arenaContestIncluded = response.included || [];
  const arenaContestData: TransformedArenaContestResponses = response.data?.map(
    (contestDataSet) => {
      const { attributes, id, relationships, type } = contestDataSet;
      const predictions = relationships.predictions.data;

      // filter arenaContestIncluded predictions for only items that match predictionIds
      const includedItemsFilteredByPredictionsIds = arenaContestIncluded.filter(
        (item) => predictions.some((prediction) => prediction.id === item.id)
      );
      const {
        contest_id: contestId,
        contest_placement: contestPlacement,
        contest_result: contestResult,
        result: entryResult,
        user_id: memberId
      } = attributes;

      const contestData = {
        contestId,
        contestPlacement,
        contestResult,
        entryResult,
        contestType: type,
        entryId: id,
        filteredIncludedItems: includedItemsFilteredByPredictionsIds,
        memberId
      };

      return contestData;
    }
  );

  const sortedArenaContestData = arenaContestData.sort(
    (a, b) => a.contestPlacement.position - b.contestPlacement.position
  );

  return sortedArenaContestData || [];
};

export const formatArenaContestDataForTable = (
  arenaContest: TransformedArenaContestResponse
) => {
  const {
    contestPlacement,
    contestResult,
    entryResult,
    entryId,
    filteredIncludedItems,
    memberId
  } = arenaContest;

  const predictionResults: PredictionStatuses = filteredIncludedItems.map(
    (item) => item.attributes.result as PredictionStatus
  );

  // PICKS
  const correctPicks = predictionResults.filter((pick) => pick === 'correct');
  const picksResultString = `${correctPicks.length} of ${predictionResults.length}`;

  // DEMONS/GOBLINS
  let demonCount = 0;
  let goblinCount = 0;

  filteredIncludedItems.forEach((item) => {
    if ((item.attributes.result as PredictionStatus) === 'correct') {
      if ((item.attributes.odds_type as OddsType) === 'demon') {
        demonCount += 1;
      } else if ((item.attributes.odds_type as OddsType) === 'goblin') {
        goblinCount += 1;
      }
    }
  });

  // TIED/DNP
  const tiedDnp = predictionResults.filter(
    (result) => result === 'tie' || result === 'dnp'
  );

  // REBOOTS
  const reboots = predictionResults.filter((result) => result === 'reboot');
  return {
    correctDemons: demonCount,
    correctGoblins: goblinCount,
    entryId,
    entryResult,
    memberId,
    picks: picksResultString,
    rank: contestPlacement.position,
    reboots: reboots.length,
    result: contestResult,
    score: contestPlacement.score,
    tiedDnp: tiedDnp.length
  };
};
